// extracted by mini-css-extract-plugin
export default {"list":"SwapConfirm_list__nwyEl","item":"SwapConfirm_item__vk9rX","article":"SwapConfirm_article__5MHpt","title":"SwapConfirm_title__IjIt5","content":"SwapConfirm_content__3obgf"};